var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor create-ticket" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.createTicketSubject"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.createTicketSubjectPh"),
                "show-attributes": true,
                "show-emoji": true,
                "max-character-count": 1024,
              },
              model: {
                value: _vm.clone.subject,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "subject", $$v)
                },
                expression: "clone.subject",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.createTicketVisitorEmail"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.createTicketVisitorEmailPh"),
                "show-attributes": true,
                "show-emoji": false,
                "max-character-count": 400,
              },
              model: {
                value: _vm.clone.visitorEmailAddress,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "visitorEmailAddress", $$v)
                },
                expression: "clone.visitorEmailAddress",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.createTicketVisitorPhone"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.createTicketVisitorPhonePh"),
                "show-attributes": true,
                "show-emoji": false,
                "max-character-count": 400,
              },
              model: {
                value: _vm.clone.visitorPhoneNumber,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "visitorPhoneNumber", $$v)
                },
                expression: "clone.visitorPhoneNumber",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.createTicketTag"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("a-auto-complete", {
              staticClass: "w-100",
              attrs: {
                "data-source": _vm.tagList,
                placeholder: _vm.$t("chatbotv2.createTicketTagPh"),
              },
              on: {
                select: _vm.onSelect,
                search: _vm.onSearch,
                change: _vm.onChange,
              },
              model: {
                value: _vm.clone.tag,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "tag", $$v)
                },
                expression: "clone.tag",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }